import { useEffect, useMemo, useState } from "react";
import Sos from "./img/wilmas.jpg";
import "./css/index.css";
import { getSubpages } from "./api/infoBoxApi";
import { useAuthInfo } from "./auth/hooks";
import { useNavigate } from "react-router-dom";

function Home() {
  const [activeTab, setActiveTab] = useState("");
  const [tabs, setTabs] = useState([]);
  const [contentById, setContentById] = useState({});
  const [error, setError] = useState("");

  const authInfo = useAuthInfo();
  const navigate = useNavigate();

  const isAuthenticated = authInfo?.isAuthenticated ?? false;
  const user = authInfo?.user ?? null; 

  useEffect(() => {
    (async () => {
      try {
        setError("");

        const pages = await getSubpages();
        const front = (pages || []).find((p) => p.pageName === "frontpage");

        const boxes = front?.info_boxes;
        if (!front || !Array.isArray(boxes) || boxes.length === 0) {
          setError("Oops - something went wrong");
          return;
        }

        const nextTabs = boxes.map((box, idx) => ({
          id: `box-${idx}`,
          label: String(box?.title || `Box ${idx + 1}`),
        }));

        const map = {};
        boxes.forEach((box, idx) => {
          map[`box-${idx}`] = { html: String(box?.content || "") };
        });

        setTabs(nextTabs);
        setContentById(map);
        setActiveTab(nextTabs[0]?.id || "");
      } catch (e) {
        setError("Oops - something went wrong");
      }
    })();
  }, []);

  const renderedPanel = useMemo(() => {
    if (!activeTab) return null;
    const box = contentById[activeTab];
    if (!box?.html) return null;
    return <div dangerouslySetInnerHTML={{ __html: box.html }} />;
  }, [activeTab, contentById]);

  if (!authInfo) return null;

  return (
    <div>
      <header className="top-bar">
        <div className="logo-section">
          <div className="logo-wrapper">
            <img
              src={require("./img/svk.png")}
              alt="Scoutkåren logo"
              className="logo-img"
            />
            <div className="logo-bubble">Välkommen! 🌲</div>
          </div>
        </div>

        <nav className="header-tabs" role="tablist" aria-label="Startsidans information">
          {tabs.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={activeTab === t.id}
              className={`header-tab ${activeTab === t.id ? "active" : ""}`}
              onClick={() => setActiveTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </nav>

        <div className="nav-buttons">
          {!isAuthenticated ? (
            <button onClick={() => navigate("/login")} className="nav-btn primary">
              För medlemmar
            </button>
          ) : (
            <>
              <button onClick={() => navigate("/homelogin")} className="nav-btn primary">
                Medlemssida
              </button>

              <button onClick={() => navigate("/logout")} className="nav-btn secondary">
                Logga ut
              </button>
            </>
          )}
        </div>
      </header>

      <div className="page">
        <div className="page-bg" style={{ backgroundImage: `url(${Sos})` }} />

        <div className="page-content">
          <div className="hero">
            <h1 className="img-txt">Scoutkåren Vasa Korsfarare</h1>

            <div className="text-box" role="tabpanel">
              {error ? <p>Oops - something went wrong</p> : renderedPanel}
            </div>
          </div>
        </div>

        <footer className="site-footer">
          <p>Scoutkåren Vasa Korsfarare r.f.</p>
          <p>Kontakt: Anna Härmälä</p>
          <p>anna.harmala@scout.fi</p>
          <p>© {new Date().getFullYear()}</p>
        </footer>
      </div>
    </div>
  );
}


export default Home;
